import logo from '../../../../assets/images/logo-catalogo.svg';
import InputSearch from '../../../../components/InputSearch';
import RadiosSearch from '../../../../components/RadiosSearch';
import styles from './styles.module.css';

function Search({
  term,
  handleKeyPress,
  handleButtonPress,
  onChange,
  index,
  selectIndex,
}) {
  return (
    <div className={`mdn-Container ${styles.Container}`}>
      <img className={styles.Logo} src={logo} alt="Logo - Claro Catálogo" />
      <InputSearch
        term={term}
        handleKeyPress={handleKeyPress}
        handleButtonPress={handleButtonPress}
        onChange={(e) => onChange(e.target.value)}
      />
      <RadiosSearch
        index={index}
        selectIndex={selectIndex}
        className={styles.RadioIndex}
      />
    </div>
  );
}

export default Search;
